import { API_CONFIG } from './api/config';

export function normalizeGatewayBackedServiceBaseUrl(rawUrl) {
    if (typeof rawUrl !== 'string') {
        return '';
    }
    const trimmed = rawUrl.trim();
    if (!trimmed) {
        return '';
    }
    return trimmed.replace(/\/+$/, '').replace(/\/api$/i, '');
}

export function resolveGatewayBackedServiceBaseUrl(explicitBaseUrl) {
    const normalizedExplicitBaseUrl = normalizeGatewayBackedServiceBaseUrl(explicitBaseUrl);
    if (normalizedExplicitBaseUrl) {
        return normalizedExplicitBaseUrl;
    }

    const normalizedGatewayBaseUrl = normalizeGatewayBackedServiceBaseUrl(API_CONFIG.BASE_URL);
    if (!normalizedGatewayBaseUrl) {
        throw new Error('API base URL is not configured');
    }

    return normalizedGatewayBaseUrl;
}
